import React from 'react';

export const HamburgerIcon = ({ fill = 'white', width = 16, height = 12 }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        id="icon"
        d="M0 0H16V2H0V0ZM0 5H16V7H0V5ZM0 10H16V12H0V10Z"
        fill={fill}
      />
    </svg>
  );
};
